import React from "react";
import {
  SectionCard,
  StatCard,
  StatusBadge,
  EmptyState,
  Pagination,
} from "../../../components/panel/PanelUI";

function formatToman(value) {
  if (value === undefined || value === null) return "—";
  return `${Number(value).toLocaleString("fa-IR")} تومان`;
}

export default function FinanceView({
  summary,
  transactions,
  page,
  totalPages,
  onPageChange,
}) {
  return (
    <div className="flex flex-col gap-5">
      {/* کارت‌های آماری */}
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        <StatCard
          label="موجودی فعلی"
          value={formatToman(summary?.balance)}
          icon="💰"
          tone="navy"
        />
        <StatCard
          label="جمع واریزی‌ها"
          value={formatToman(summary?.totalIncome)}
          icon="⬇️"
          tone="green"
        />
        <StatCard
          label="جمع برداشت‌ها / هزینه‌ها"
          value={formatToman(summary?.totalExpense)}
          icon="⬆️"
          tone="red"
        />
      </div>

      {/* جدول تراکنش‌ها */}
      <SectionCard title="تراکنش‌های اخیر">
        {!transactions || transactions.length === 0 ? (
          <EmptyState
            icon="🧾"
            title="هنوز تراکنشی ثبت نشده"
            description="تراکنش‌های مالی شما اینجا نمایش داده می‌شود."
          />
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="w-full min-w-[520px] text-right text-sm">
                <thead>
                  <tr className="border-b border-gray-100 text-xs text-gray-400">
                    <th className="pb-2 font-bold">شرح</th>
                    <th className="pb-2 font-bold">مبلغ</th>
                    <th className="pb-2 font-bold">تاریخ</th>
                    <th className="pb-2 font-bold">وضعیت</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.map((tx) => (
                    <tr
                      key={tx.id}
                      className="border-b border-gray-50 last:border-0"
                    >
                      <td className="py-3 font-semibold text-navy">
                        {tx.description || "—"}
                      </td>
                      <td
                        className={`py-3 font-bold ${
                          tx.type === "expense"
                            ? "text-red-600"
                            : "text-green-600"
                        }`}
                      >
                        {tx.type === "expense" ? "-" : "+"}
                        {formatToman(tx.amount)}
                      </td>
                      <td className="py-3 text-xs text-gray-500">
                        {tx.date}
                      </td>
                      <td className="py-3">
                        <StatusBadge status={tx.status} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Pagination
              page={page}
              totalPages={totalPages}
              onChange={onPageChange}
            />
          </>
        )}
      </SectionCard>
    </div>
  );
}
